import { Map } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    jwt: null,
    refreshJWT: null,
    clientID: null,
    phoneNumber: null,
    isApp: false,
    appDetails: {},
    isCateringMode: false,
})

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.SET_JWT: {
            return state.merge({
                jwt: payload.access_token,
                refreshJWT: payload.refresh_token,
            })
        }

        case actions.REMOVE_JWT: {
            return state.set('jwt', null)
        }

        case actions.SET_CLIENT_ID: {
            return state.set('clientID', payload)
        }

        case actions.SET_PHONE_NUMBER: {
            return state.set('phoneNumber', payload)
        }

        case actions.SET_IS_APP: {
            return state.set('isApp', payload)
        }

        case actions.SET_APP_DETAILS: {
            return state.set('appDetails', payload)
        }

        case actions.SET_CATERING_MODE: {
            return state.set('isCateringMode', payload)
        }

        default:
            return state
    }
}
